export interface User {
    id: string;
    display_name: string;
    email: string;
    present_in_org: boolean;
    selected: boolean;
    is_deleted: boolean;
}

export enum ImportStep {
    USER_SELECTION = 'user_selection',
    EMAIL_COLLECTION = 'email_collection'
}

export interface UsersResponse {
    message: string;
    users: User[];
    summary: {
        total_azure_users: number;
        currently_in_org: number;
        deleted_users: number;
    };
}

export interface ImportUsersResponse {
    message: string;
}

export interface UsersState {
    users: User[];
    initialUsers: User[];
    loading: boolean;
    importLoading: boolean;
    error: string | null;
    importError: string | null;
    importSuccess: boolean;
    summary: {
        total_azure_users: number;
        currently_in_org: number;
        deleted_users: number;
    } | null;
    importStep: ImportStep;
    userEmails: Record<string, string>; // userId -> email mapping
}


export enum UserRole {
    ADMIN = 'admin',
    BASIC_MEMBER = 'basic_member',
}